import { Tag } from "../../components/tag/Tag";
import { useDeliveryAreaList } from "../../hooks/api/v2/deliveryArea/useDeliveryAreaList";

export const useUniqueDirectPostcodes = (passedPostcodes?: string[]) => {
  const { data: deliveryAreasData } = useDeliveryAreaList({});

  const postcodes =
    passedPostcodes ??
    deliveryAreasData?.pages.flatMap((p) =>
      p.flatMap((da) =>
        da.DeliveryAreaPostcodes.flatMap((po) => po.postcodeComponent),
      ),
    ) ??
    [];

  const uniquePostcodes = [...new Set(postcodes)];
  const displayedPostcodes = uniquePostcodes.slice(0, 5);
  const remainingCount = uniquePostcodes.length - displayedPostcodes.length;

  return {
    hasPostcodes: uniquePostcodes.length > 0,
    textList: (
      <span className="flex items-center gap-1">
        {displayedPostcodes.join(", ")}
        {remainingCount > 0 && (
          <span className="font-semibold">+{remainingCount} more</span>
        )}
      </span>
    ),
    tagList: (
      <div className="flex w-full flex-wrap items-center gap-2">
        {uniquePostcodes.map((postcode, idx) => (
          <Tag key={idx}>{postcode}</Tag>
        ))}
      </div>
    ),
  };
};
